import { makeHttpRequest } from "@/shared";

export const deleteInventoryStatus = async (id) => {
    return (
        await makeHttpRequest({
            url: `/inventory/state/${id}`,
            method: "DELETE",
        })
    ).data;
};
